import { MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { wa, WA_MESSAGES } from "@/lib/site";

export default function Offer({ promo }) {
  return (
    <section data-testid="offer-section" className="grain bg-forest py-24 md:py-28">
      <div className="mx-auto max-w-5xl px-5 text-center md:px-10">
        {promo?.active && (
          <Reveal>
            <span
              data-testid="offer-limited-badge"
              className="inline-block rounded-full border border-gold/60 bg-gold/10 px-6 py-2 text-[11px] font-bold uppercase tracking-[0.3em] text-gold"
            >
              Limited-Time Offer{promo.text ? ` — ${promo.text}` : ""}
            </span>
          </Reveal>
        )}
        <Reveal delay={0.08}>
          <h2 className="mt-8 font-heading text-5xl leading-[1.05] text-ivory sm:text-6xl lg:text-7xl">
            Bring MAHIRA <span className="italic text-gold">Home</span>
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mx-auto mt-6 max-w-xl text-base text-ivory/70 md:text-lg">
            Experience premium Indian ghee, delivered to your doorstep.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <a
            data-testid="offer-order-now"
            href={wa(WA_MESSAGES.order())}
            target="_blank"
            rel="noreferrer"
            className="mt-10 inline-flex items-center gap-3 rounded-full bg-gold px-10 py-5 text-[12px] font-bold uppercase tracking-[0.2em] text-forest transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-gold-light"
          >
            <MessageCircle className="h-4 w-4" />
            Order Now
          </a>
        </Reveal>
      </div>
    </section>
  );
}
